import { useStaticQuery, graphql } from 'gatsby';

// Custom hook to fetch theme
export const useDatoTheme = () => {
	const data = useStaticQuery(graphql`
		query {
			config: datoCmsConfig {
				theme
			}
		}
	`);

	return data?.config?.theme || 'default'; // Fallback theme if undefined
};
